<template>
  <div>
    <Header />

    <div class="content-web container mt-5">
      <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
          <div class="col-12">
            <label class="title">BỘ LỌC:</label>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
            <date-picker
              v-model="dateFormSearch.fromDate"
              placeholder="From Date"
              type="date"
              class="date-control mr-2 mb-2"
              value-type="YYYY-MM-DD"
              :disabled-date="disabledSearchFromDate"
            ></date-picker>
            <date-picker
              v-model="dateFormSearch.toDate"
              placeholder="To Date"
              type="date"
              value-type="YYYY-MM-DD"
              class="date-control mr-2 mb-2"
              :disabled-date="disabledSearchToDate"
            ></date-picker>
            <button
              class="btn btn_control mr-1 mb-2"
              @keyup.enter="searchAll()"
              @click="searchAll()"
            >Tìm Kiếm</button>
            <button
              class="btn btn_control mr-1 mb-2"
              @keyup.enter="exportExcel()"
              @click="exportExcel()"
            >Tải xuống</button>
          </div>
        </div>
        <div class="row"> 
           <div class="col-12 d-flex mr-2 mb-2">     
           <div v-for="item in tabListYear" :key="item"> 
              <button
                class="btn btn_control mr-1 mb-2"
                @click="getDataByYear(item)"
              >{{ item }}</button>                   
            </div>
           </div>
        </div>
      </div>

      <div class="mt-2 mb-2" style="height: 500px" v-if="loading">
        <div class="text-center">
          <div class="spinner-border text-dark" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="BÁO CÁO" name="first">
      <div v-show="!loading" class="mt-2 mb-5">
        <div class="clearfix">
          <div id="sumary_panel_location">
            <div class="panel panel-default" id="summary_content">
              <div class="char-body">
                <div class="container-fluid row ml-0 mr-0" style="display: flex;align-items: center;">
                  <div id="summaryChart" class="cover col-12 col-sm-12 col-md-4 col-lg-4 p-0"></div>

                  <div class="col-12 col-sm-12 col-md-8 col-lg-8 desc-chart content-table p-0">
                    <table class="table table-responsive tbl_summary table-hover">
                      <thead>
                        <tr class="summary-heading">
                          <td class="px-1"> CÔNG TY THÀNH VIÊN</td>
                          <td style="width:25%">Công nhận sáng kiến </td>
                          <td style="width:15%">Hồ sơ đáp ứng yêu cầu </td>
                          <td style="width:15%">Chờ sơ loại </td>
                          <td style="width:15%">Yêu cầu cập nhật </td>
                          <td style="width:15%">Hồ sơ không đáp ứng/ không công nhận</td>
                          <td style="width:15%">Thưởng theo chính sách của tập đoàn</td>
                          <td style="width:15%">Số sáng kiến đã thi iKhien</td>
                          <td style="width:20%">Thời gian trung bình sáng kiến được CTTV phê duyệt(ngày) </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style="text-align:center"
                          v-for="(item,index) in summary"
                          v-bind:key="item.id"
                          class="summary-data-detail"
                        >
                          <td>
                            <i class="fa fa-square" v-bind:style="{ color:colors[index]  }"></i>
                            {{item.company}}
                          </td>
                          <td>{{item.publish}}</td>
                          <td>{{item.submit}}</td>
                          <td>{{item.preliminaryExamination}}</td>
                          <td>{{item.request}}</td>
                          <td>{{item.reject}}</td>
                          <td>{{item.groupBonusMoney}}</td>
                          <td>{{item.ideaContest}}</td>
                          <td>{{item.publish == 0 ? item.publish.toFixed(2) : (item.avgdate/item.publish).toFixed(2) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </el-tab-pane>

      <el-tab-pane label="THÔNG TIN THƯỞNG" name="second">
        <div class="col-12 col-sm-12 content-table p-0">
            <table class="table table-responsive tbl_summary table-hover">
              <thead>
                <tr class="idea-bonus-heading">
                  <td class="px-1" > Công ty </td>
                  <td class="px-1" > Tên sáng kiến </td>
                  <td style="width:20%">Loại hiệu quả </td>
                  <td style="width:20%">Giá trị làm lợi </td>                         
                  <td style="width:15%">Thưởng khuyến khích của công ty (VND) </td>
                  <td style="width:15%">Thưởng theo chính sách của tập đoàn </td>
                </tr>
              </thead>
              <tbody>
                <tr style="text-align:center"
                  v-for="item in listIdea"
                  v-bind:key="item.id"
                  class="idead-with-bonus-data-detail"
                >
                  <td>{{item.companyCode}}</td>
                  <td>                   
                    {{item.title}}
                  </td>
                  <td>{{item.effectiveType}}</td>
                  <td>{{item.effectiveEstimate}}</td>
                  <td>{{item.bonusMoney}}</td>
                  <td>{{item.groupBonusMoney}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row mt-4 pagination">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
              <span v-if="perPage * page > totalData && totalData != 0"
                >{{ perPage * (page - 1) + 1 }}-{{ totalData }} của
                {{ totalData }}</span
              >
              <span v-if="perPage * page <= totalData && totalData != 0"
                >{{ perPage * (page - 1) + 1 }}-{{ perPage * page }} của
                {{ totalData }}</span
              >
              <span v-if="totalData == 0">0-0 của 0</span>
            </div>
            <div
              class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex"
            >
              <b-pagination
                v-if="totalData > perPage"
                v-model="page"
                pills
                :total-rows="totalData"
                :per-page="perPage"
              ></b-pagination>
            </div>
        </div>

      </el-tab-pane>
    </el-tabs>

      <!-- <div v-show="!loading" class="mt-2 mb-5">
        <div class="clearfix">
          <div id="sumary_panel_location">
            <div class="panel panel-default" id="summary_content">
              <div class="chart-header">
                <h4>BÁO CÁO</h4>
              </div>
              <div class="char-body">
                <div class="container-fluid row ml-0 mr-0" style="display: flex;align-items: center;">
                  <div id="summaryChart" class="cover col-12 col-sm-12 col-md-4 col-lg-4 p-0"></div>

                  <div class="col-12 col-sm-12 col-md-8 col-lg-8 desc-chart content-table p-0">
                    <table class="table table-responsive tbl_summary table-hover">
                      <thead>
                        <tr class="summary-heading">
                          <td class="px-1"> CÔNG TY THÀNH VIÊN</td>
                          <td style="width:25%">Công nhận sáng kiến </td>
                          <td style="width:15%">Hồ sơ đáp ứng yêu cầu </td>
                          <td style="width:15%">Chờ sơ loại </td>
                          <td style="width:15%">Yêu cầu cập nhật </td>
                          <td style="width:15%">Hồ sơ không đáp ứng/ không công nhận</td>
                          <td style="width:15%">Thưởng theo chính sách của tập đoàn</td>
                          <td style="width:15%">Số sáng kiến đã thi iKhien</td>
                          <td style="width:20%">Thời gian trung bình sáng kiến được CTTV phê duyệt(ngày) </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style="text-align:center"
                          v-for="(item,index) in summary"
                          v-bind:key="item.id"
                          class="summary-data-detail"
                        >
                          <td>
                            <i class="fa fa-square" v-bind:style="{ color:colors[index]  }"></i>
                            {{item.company}}
                          </td>
                          <td>{{item.publish}}</td>
                          <td>{{item.submit}}</td>
                          <td>{{item.preliminaryExamination}}</td>
                          <td>{{item.request}}</td>
                          <td>{{item.reject}}</td>
                          <td>{{item.groupBonusMoney}}</td>
                          <td>{{item.ideaContest}}</td>
                          <td>{{(item.avgdate/item.publish).toFixed(2)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <Footer />
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueHighcharts from "vue2-highcharts";
import Exporting from "highcharts/modules/exporting";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";
import Highcharts from "highcharts";
import axios from "axios";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import * as CONFIG from "../../config/index";
import HighchartsVue from "highcharts-vue";
import moment from "moment";

export default {
  components: {
    VueHighcharts,
    Header,
    Footer,
    DatePicker
  },

  data() {
    return {
      page: 1,
      perPage: 10,
      totalPages: 0,
      totalData: 0,
      listIdea : [],
      activeName: 'first',
      fsuCombobox: [],
      fsuSelected: {
        name: "FSOFT",
        deptCode: "FSOFT"
      },
      fsuCode: "",
      mostViewIP: "",
      totalSubmitter: "",
      dateHidden: "",
      checkDate: "",
      listTopUtilization: [],
      listSummary: [],
      summary: [],
      summaryChart: {},
      dateFormSearch: {
        fromDate: "",
        toDate: ""
      },
      dateFormSearchByYear: {
        fromDate: "",
        toDate: ""
      },
      totalIps: 0,
      colors: [
        "#DD2D32",
        "#00FF00",
        "#63AAFE",
        "#FFF58C",
        "#FEA746",
        "#865357",
        "#339966",
        "#00CCFF",
        "#CCFFFF",
        "#DF5353",
        "#FFCC00",
        "#FF9900"
      ],
      // ipDetailUrl: `${CONFIG.CLIENT_URL}/#/ip-view`,
      // profileUrl: `${CONFIG.CLIENT_URL}/#/my-profile`,
      loading: false,
      tabListYear : []
    };
  },
  created() {
    this.getTabList();
    this.getIdeaWithBonus();
  }, 
    watch: {
    page: {
      immediate: false,
      handler(newVal, oldVal) {
        this.getIdeaWithBonus();
      },
    },
  }, 
  methods: {
    async getTabList(){
      let startYear = 2020;
      let endYear = new Date().getFullYear();     
      for(var i= startYear; i<= endYear;i++){      
        this.tabListYear.push(i)
      }
    },

    disabledTimeFrom(date) {
      if (this.dateFormSearch.toDate) {
        return date > this.dateFormSearch.toDate;
      }
    },
    disabledTimeTo(date) {
      return date < this.dateFormSearch.fromDate;
    },
    redirect: function(href) {
      window.location.href = href;
    },

    async getIdeaWithBonusByYear(data){
      let dateCurrent = new Date();
      console.log(dateCurrent.getFullYear())
      this.dateFormSearchByYear.fromDate = new Date("01/01/" + data);
      if(data === dateCurrent.getFullYear()){      
        this.dateFormSearchByYear.toDate = new Date()
      }else{
        this.dateFormSearchByYear.toDate = new Date("12/31/" + data);
      }

      await this.axios
        .post(
          `${CONFIG.API_URL}/headline/getIdeaWithBonusMoney?pageNo=` +
            this.page + `&pageSize=` + this.perPage ,
          this.dateFormSearchByYear
        )
        .then(res => {
          this.listIdea = res.data.data.items
          this.totalPages = Math.ceil(res.data.data.totals / this.perPage);
          this.totalData = res.data.data.totals;
        });  

    },

    async getIdeaWithBonus() {
      await this.axios
        .post(
          `${CONFIG.API_URL}/headline/getIdeaWithBonusMoney?pageNo=` +
            this.page + `&pageSize=` + this.perPage ,
          this.dateFormSearch
        )
        .then(res => {
          this.listIdea = res.data.data.items
          this.totalPages = Math.ceil(res.data.data.totals / this.perPage);
          this.totalData = res.data.data.totals;
        });
    },    

    async getDataByYear(data){
      if(this.activeName == "second"){
        this.getIdeaWithBonusByYear(data)
      }else{
        this.getSummaryByYear(data);
      }
    },

    async getSummaryByYear(data){
      let dateCurrent = new Date();
      console.log(dateCurrent.getFullYear())
      this.dateFormSearchByYear.fromDate = new Date("01/01/" + data);
      if(data === dateCurrent.getFullYear()){      
        this.dateFormSearchByYear.toDate = new Date()
      }else{
        this.dateFormSearchByYear.toDate = new Date("12/31/" + data);
      }
      this.totalIps = 0;
      this.totalView = 0;
      this.totalSubmit = 0;
      this.listSummary = [];
      await this.axios
        .post(
          `${CONFIG.API_URL}/headline/summary`,
          this.dateFormSearchByYear
        )
        .then(res => {
          console.log(res);
          this.summary = res.data.data;
          this.summary.forEach(s => {
            this.totalIps = this.totalIps + s.amount;
            var list = [];
            list.push(s.company);
            list.push(s.amount);
            this.listSummary.push(list);
          });
          this.renderPieChart();
        });   
    },

    async searchAll(){
      if(this.activeName == "second"){
        this.getIdeaWithBonus()
      }else{
        this.getSummary();
      }
    },

    async getSummary() {
      this.totalIps = 0;
      this.totalView = 0;
      this.totalSubmit = 0;
      this.listSummary = [];
      await this.axios
        .post(
          `${CONFIG.API_URL}/headline/summary`,
          this.dateFormSearch
        )
        .then(res => {
          console.log(res);
          this.summary = res.data.data;
          this.summary.forEach(s => {
            this.totalIps = this.totalIps + s.amount;
            var list = [];
            list.push(s.company);
            list.push(s.amount);
            this.listSummary.push(list);
          });
          this.renderPieChart();
        });
    },
    renderPieChart: function() {
      this.summaryChart = new Highcharts.Chart({
        chart: {
          renderTo: "summaryChart",
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 200
          }
        },
        colors: this.colors,
        title: {
          text:
            ' <div class="count-ips text-center" style=" font-weight:700; font-size: 24px; color: #3E9FBE; margin: 0px; padding: 0px; line-height: 42px;"> <p id="total-acount">' +
            this.totalIps +
            "</p> </div>" +
            '<br><div style="font-family: Roboto ;font-style: normal;font-weight: 500;font-size: 20px;line-height: 21px;"> Sáng kiến </div>',
          align: "center",
          verticalAlign: "middle",
          y: 30
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          pie: {
            size: 250,
            innerSize: 120,
            depth: 100
          },
          series: {
            dataLabels: {
              enabled: false
            }
          }
        },
        color: {},
        series: [
          {
            name: "",
            data: this.listSummary
          }
        ]
      });
    },
    disabledSearchFromDate(date) {
      if (this.dateFormSearch.toDate) {
        return date > this.dateFormSearch.toDate;
      }
    },
    disabledSearchToDate(date) {
      return date < this.dateFormSearch.fromDate;
    },
    exportExcel: function() {
      this.axios
        .post(`${CONFIG.API_URL}/headline/export`, this.dateFormSearch, {
          responseType: "blob"
        })
        .then(res => {
          const headers = res.headers;
          const blob = new Blob([res.data], { type: headers["content-type"] });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "Report.xls";
          link.click();
        })
        .catch(err => {
          console.error(err);
        });
    },

    handleClick(){
      console.log("activeName",this.activeName)        
    }
    
  },
  async mounted() {
    this.loading = true;
    await Promise.all([
      this.getSummary()           
    ]).then(res => {
      this.loading = false;
    })
    .catch(error => {
      this.loading = false;
    });
  }
};
</script>
<style  scoped>
@import "../../assets/css/filter_customs.css";

@keyframes chartjs-render-animation {
  from {
    opacity: 0.99;
  }
  to {
    opacity: 1;
  }
}

#btnSearch {
  box-shadow: 0px 10px 10px rgba(237, 134, 82, 0.05);
  border-radius: 20px;
  margin-right: 5px !important;
  margin-bottom: 5px !important;
  background-color: #3199bb !important;
  border-color: #3199bb !important;
  height: 35px !important;
  width: 90px !important;
  font-size: 14px !important;
  color: #fff;
}
.chartjs-render-monitor {
  animation: chartjs-render-animation 0.001s;
}

/*
 * DOM element resizing detection
 * https://github.com/marcj/css-element-queries
 */
.chartjs-size-monitor,
.chartjs-size-monitor-expand,
.chartjs-size-monitor-shrink {
  position: absolute;
  direction: ltr;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}

.chartjs-size-monitor-expand > div {
  position: absolute;
  width: 1000000px;
  height: 1000000px;
  left: 0;
  top: 0;
}

/*! CSS Used from: Embedded */
.cover .count-ips {
  position: absolute;
  width: 100%;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  color: #1e242f;
  font-size: 12px;
}
.cover .count-ips p {
  font-size: 54px;
  color: #1e242f;
  margin: 0px;
  padding: 0px;
  line-height: 55px;
}

.chartjs-size-monitor-shrink > div {
  position: absolute;
  width: 200%;
  height: 200%;
  left: 0;
  top: 0;
}

.panel {
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.panel-default {
  border-color: #ddd;
}
.clearfix:after,
.clearfix:before {
  display: table;
  content: " ";
}
.clearfix:after {
  clear: both;
}
/*! CSS Used from: https://fi20-dev.fsoft.com.vn/sku/resources/inspinia/css/style.css */
h4 {
  font-weight: 100;
}
h4 {
  font-size: 14px;
}
h4 {
  margin-top: 5px;
  font-weight: 600;
}
.panel {
  box-shadow: none;
}

/*! CSS Used from: Embedded */
.chart-header {
  padding: 0px;
  margin: 0px;
}
.chart-header h4 {
  padding: 0px 10px;
  font-size: 14px;
  text-transform: uppercase;
}
/*! CSS Used from: Embedded */
.chart-header {
  border-left: 8px solid #3199bb;
}

.media-body {
  overflow: hidden;
  zoom: 1;
  height: 58px;
}
#username {
  font-size: 10px;
  color: #4ea198;
  font-weight: bold;
}
.media-heading {
  margin: 0;
  line-height: 18px;
}

.media-heading a {
  font-size: 13px;
  color: black;
  display: block;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
#content_type_location {
  font-size: 10px;
  color: #e07254;
  font-weight: bold;
}
.meta {
  font-size: 13px;
}

#title-submission {
  font-size: 14px;
  font-weight: bold;
  color: #3299ba;
}
/*! CSS Used from: Embedded */
.qualified-and-utilization [class*="col"] {
  padding-right: 10px;
  padding-left: 10px;
}
/*! CSS Used from: Embedded */
.chart-header {
  padding: 5px 0;
  margin-top: 20px;
  margin-bottom: 20px;
}
/*! CSS Used from: Embedded */
.FSU-report [class*="col"] {
  padding-right: 10px;
  padding-left: 10px;
}

#top_tag_content {
  border: 1px solid lightgray;
  padding-bottom: 30px;
  height: 100%;
}
#top_tag_content_detail select {
  border-radius: 3px;
  border: solid 1px #c7ced5;
}
/*! CSS Used from: Embedded */
.chartjs-render-monitor {
  animation: chartjs-render-animation 1ms;
}
.chartjs-size-monitor,
.chartjs-size-monitor-expand,
.chartjs-size-monitor-shrink {
  position: absolute;
  direction: ltr;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}
.chartjs-size-monitor-expand > div {
  position: absolute;
  width: 1000000px;
  height: 1000000px;
  left: 0;
  top: 0;
}
.top_sme_content_detail {
  padding: 10px;
  text-align: right;
  color: #1e242f;
  font-size: 14px;
}
#top_sme_name_display {
  text-align: left;
  color: #3299ba;
  font-size: 14px;
  font-weight: bold;
}
.top_sme_table_content {
  background-color: #fff;
  font-size: 14px;
  color: #333;
  width: 100%;
}
#top_sme_descrshort {
  font-size: 10px;
  color: #e07254;
  font-weight: bold;
}
.top_sme_heading {
  color: #677897;
  background-color: white;
  font-size: 12px;
}
.top-contributor-dashboard {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ff9900;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
}

.chartjs-size-monitor-shrink > div {
  position: absolute;
  width: 200%;
  height: 200%;
  left: 0;
  top: 0;
}
/*! CSS Used from: https://fi20-dev.fsoft.com.vn/sku/resources/base/css/custom/Chart.css */
.chartjs-render-monitor {
  animation: chartjs-render-animation 0.001s;
}
.chartjs-size-monitor,
.chartjs-size-monitor-expand,
.chartjs-size-monitor-shrink {
  position: absolute;
  direction: ltr;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}
.chartjs-size-monitor-expand > div {
  position: absolute;
  width: 1000000px;
  height: 1000000px;
  left: 0;
  top: 0;
}
.chartjs-size-monitor-shrink > div {
  position: absolute;
  width: 200%;
  height: 200%;
  left: 0;
  top: 0;
}

/*! CSS Used from: Embedded */
.qualified-and-utilization [class*="col"] {
  padding-right: 10px;
  padding-left: 10px;
}
/*! CSS Used keyframes */
@keyframes chartjs-render-animation {
  from {
    opacity: 0.99;
  }
  to {
    opacity: 1;
  }
}
@keyframes chartjs-render-animation {
  from {
    opacity: 0.99;
  }
  to {
    opacity: 1;
  }
}
.sku_chart_top-ulitization {
  border: 1px solid lightgray;
  /* background-color: #fff; */
}

.chart-body {
  background-color: #fff;
}
.media-body {
  overflow: hidden;
  zoom: 1;
}

/*! CSS Used from: Embedded */
.key1 {
  display: block;
  font-size: 10px;
  color: #1e242f;
  text-transform: uppercase;
}
.number1 {
  display: block;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  color: #3299ba;
}
/*! CSS Used from: Embedded */
.sumary-toptag [class*="col"] {
  padding-right: 10px;
  padding-left: 10px;
}
table td {
  font-family: Roboto;
  font-weight: 700;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
}
#summary_content {
  border: 1px solid #ddd;
  padding-bottom: 30px;
  height: 100%;
  border-radius: 0;
}
.summary-heading td {
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.06px;
  text-align: right;
  color: #898e97;
  text-transform: uppercase;
}
.summary-data-detail td {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.07px;
  text-align: right;
  color: #1e242f;
}

.idea-bonus-heading td {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.5;
  letter-spacing: 0.06px;
  text-align: left;
  color: #898e97;
  text-transform: uppercase;
}

.idead-with-bonus-data-detail td {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.07px;
  text-align: left;
  color: #1e242f;
  padding-left:5px ;
}

.sku-dashboard-summary {
  font-family: Roboto !important;
  font-style: bold;
  font-weight: 500;
  font-size: 28px;
  margin-top: 35px;
  margin-bottom: 25px;
}
.fa-square {
  padding-right: 5px;
}
.quang-cute > tbody > tr > td:first-child {
  width: 55%;
}
.quang-cute > tbody > tr > td {
  border: none;
}

.chart-area {
  position: relative;
}
.cover {
  padding-top: 30px;
  padding-left: 0px;
  text-align: center;
  height: inherit;
}
.cover .count-ips {
  position: absolute;
  width: 100%;
  margin: 0 auto;
  top: 55% !important;
  transform: translateY(-50%);
  color: #1e242f;
  font-size: 12px;
  z-index: 100;
}

.hint-chart {
  color: #9e9e9e;
  text-align: center;
  font-size: 12px;
}
.panel-body {
  padding-top: 30px;
  padding-left: 10px;
}
.panel-heading > b {
  margin: 0px;
  padding: 13px;
  border-bottom: 1px solid #f0f3f6;
  box-sizing: border-box;
}
.panel-heading h4 {
  text-align: left;
  font-size: 16px;
  color: #172b4d;
}
.cover .count-ips p {
  font-size: 54px;
  color: #1e242f;
  margin: 0px;
  padding: 0px;
  line-height: 55px;
}
.chart-area .desc-chart {
  width: calc(100% - 350px);
}
.pr-5 {
  padding-right: 5px !important;
}
.overview .number {
  font-size: 30px;
  color: #0050db;
}
.desc-chart table thead tr td:nth-child(1),
.desc-chart table tbody tr td:nth-child(1) {
  text-align: left;
}
.desc-chart {
  width: calc(100% - 350px);
  float: left;
}

.cover {
  position: relative;
  padding-top: 0;
  width: 350px;
  height: auto;
  float: left;
}
#header {
  background-color: #1e242f;
}
.page-head {
  height: 100px;
  position: relative;
}

.chart-body {
  position: relative;
}

.td-contributor {
  height: 65px;
}
@media (min-width: 576px) and (max-width: 767.98px) {
  .fix-column {
    margin-top: 1.5rem !important;
  }
  .v-select-tag {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
}
@media (max-width: 767.98px) {
  .fix-column {
    margin-top: 1.5rem !important;
  }
  .v-select-tag {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
  }
}
</style>

<style>
.v-select-option .vs__dropdown-toggle {
  min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Headlines.vue